import { render, staticRenderFns } from "./agreementDialog.vue?vue&type=template&id=67609265&scoped=true&"
import script from "./agreementDialog.vue?vue&type=script&lang=ts&"
export * from "./agreementDialog.vue?vue&type=script&lang=ts&"
import style0 from "./agreementDialog.vue?vue&type=style&index=0&id=67609265&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67609265",
  null
  
)

export default component.exports